import React from 'react';
import Layout from '../components/layout';
import Hero from '../components/homepage/Hero';
import Logos from '../components/homepage/Logos';
import Mission from '../components/about/Mission';
import dialo from '../images/logo-dalio.jpg';
import dph from '../images/ma-dph.png';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-a11y-footnotes/dist/styles.css';
import './page-styles.scss';

const IndexPage = () => {
  return (
    <Layout>
      <Hero />
      <Logos />
      <Mission />
      <section className="section">
        <div className="columns is-vcentered is-centered">
          <div
            className="column is-6"
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <img src={dph} alt="dph" style={{ maxWidth: '25%' }} />
          </div>
          <div
            className="column is-6"
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <img src={dialo} alt="df" style={{ maxWidth: '50%' }} />
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="hero">
            <div className="columns">
              <div className="column">
                <h3 className="is-size-3 title is-size-3-mobile has-text-left-desktop pr-4">
                  LAND ACKNOWLEDGEMENT
                </h3>
                <div className="content">
                  <p>
                    The iDECIDE Development and Evaluation Team would like to
                    acknowledge, with gratitude and humility, that the entirety
                    of this program takes place on Indigenous land. We
                    acknowledge that the systems in which we work were founded
                    upon the exclusion and erasure of many Indigenous
                    communities. We make the commitment to continue to work to
                    understand the historical and current experiences of Native
                    peoples—through collaborative partnerships, enrollment and
                    retention efforts, community service, and more—to help
                    inform the work we do and advance the creation of more
                    inclusive spaces for all.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default IndexPage;
